import { Autocomplete, TextField } from '@mui/material';
import { ISO_COUNTRY_OPTIONS } from '../../constants/IsoCountries';

export default function VirtualCountrySelect(props: {
    value: string;
    onChange: (countryCode: string) => void;
    disabled?: boolean;
    required?: boolean;
    label?: string;
}) {
    const selectedCountry = ISO_COUNTRY_OPTIONS.find(country => country.code === props.value.toUpperCase()) ?? null;

    return <Autocomplete
        options={ISO_COUNTRY_OPTIONS}
        value={selectedCountry}
        onChange={(_, country) => props.onChange(country?.code ?? '')}
        getOptionLabel={country => country.label}
        isOptionEqualToValue={(option, value) => option.code === value.code}
        autoHighlight
        disabled={props.disabled}
        sx={{ flex: 1 }}
        renderInput={params => <TextField
            {...params}
            required={props.required ?? true}
            label={props.label ?? 'Origin country'}
        />}
    />;
}
